import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Iter 714 (Kamel) — « Vous ne payez que ce que vous vivez » : séjour = socle, car / excursions / spa à la carte. Textes dans Paramètres Espagne.
export const ALaCarteBloc = ({ compact = false }) => {
  const [a, setA] = useState(null);
  useEffect(() => { axios.get(`${API}/espagne/alacarte`).then(r => setA(r.data)).catch(() => setA(null)); }, []);
  if (!a || !a.actif) return null;
  return (
    <section className={`relative overflow-hidden rounded-3xl bg-white border-2 border-[#FFC400] ${compact ? 'p-6 md:p-8' : 'p-6 md:p-10'}`} data-testid="alacarte-bloc">
      <div className="absolute -top-16 -right-16 w-56 h-56 rounded-full bg-[#FFC400]/15 blur-3xl pointer-events-none" />
      <p className="text-[11px] font-black tracking-[0.25em] uppercase text-[#C60B1E] mb-3">Espagne · notre façon de faire</p>
      <h2 className="text-3xl md:text-4xl font-bold text-[#1E3A5F] leading-tight mb-4" data-testid="alacarte-titre">{a.titre}</h2>
      <p className="text-base md:text-lg text-gray-700 leading-relaxed max-w-3xl" data-testid="alacarte-accroche">{a.accroche}</p>
      {a.points?.length > 0 && (
        <div className={`mt-6 grid gap-4 ${a.points.length >= 3 ? 'md:grid-cols-3' : 'md:grid-cols-2'}`} data-testid="alacarte-points">
          {a.points.map((p, i) => (
            <div key={i} className="rounded-2xl bg-[#F7F3EA] px-5 py-4 border-l-4 border-[#1E3A5F]">
              <p className="font-bold text-[#1E3A5F] text-base md:text-lg">{p.titre}</p>
              {p.texte && <p className="text-sm text-gray-700 mt-1 leading-relaxed">{p.texte}</p>}
            </div>
          ))}
        </div>
      )}
      {a.badge && <p className="mt-5 inline-flex items-center gap-2 bg-[#1E3A5F] text-white rounded-full px-4 py-2 text-sm font-bold shadow" data-testid="alacarte-badge">🏷️ {a.badge}</p>}
      {a.conclusion && (
        <p className="mt-6 text-base md:text-lg font-semibold text-[#1E3A5F] bg-[#FFC400]/20 rounded-2xl px-5 py-4 leading-relaxed" data-testid="alacarte-conclusion">{a.conclusion}</p>
      )}
    </section>
  );
};

export default ALaCarteBloc;
